import { Endpoint } from "@mongez/http";
import { GenericObject } from "@mongez/reinforcements";
import { useLocation } from "@remix-run/react";
import { User, userAtom } from "core/user";
import { useState } from "react";

type ResponseWithUser<Data> = Data & {
  user: User;
};

type FetchOptions<Data> = {
  params?: GenericObject;
  onSuccess?: (data: Data) => void;
  updateState?: boolean;
};

export function useFetch<Data>(
  path?: string,
  options: FetchOptions<Data> = {},
) {
  const [data, setData] = useState<Data>();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const load = async (
    params?: GenericObject,
  ): Promise<ResponseWithUser<Data>> => {
    const updateState = options.updateState ?? true;

    if (updateState) {
      setIsLoading(true);
    }

    const endpoint = new Endpoint();

    const response = await endpoint.get<ResponseWithUser<Data>>(
      path || location.pathname,
      {
        params: {
          ...params,
          ...options.params,
        },
      },
    );

    options.onSuccess?.(response.data);

    if (updateState) {
      setData(response.data);
      setIsLoading(false);
    }

    if (response.data.user) {
      userAtom.update(response.data.user);
    }

    return response.data;
  };

  const reset = () => {
    setData(undefined);
  };

  return { load, data, reset, isLoading };
}
